import React from 'react'
import { Hero } from '../../Components/Home/Hero'
import WhyTechmentee from '../../Components/Home/WhyTechmentee'
import Programs from '../../Components/Home/Programs'
import Industry from '../../Components/Home/Industry'
import TakeTheNextStep from '../../Components/Home/TakeTheNextStep'
import FAQs from '../../Components/Home/FAQs'
import ProudMembers from '../../Components/Home/ProudMembers'
import LearnMore from '../../Components/Home/LearnMore'
import RequestCallback from '../../Components/Home/RequestCallback'
import About from '../../Components/Home/About'
import Launch from '../../Components/Home/Launch'

const Home = () => {
  return (
    <div>
      <Hero />
      <About />
      <WhyTechmentee />
      <Programs />
      <Launch />
      <Industry />
      {/* <TakeTheNextStep /> */}
      <FAQs />
      <LearnMore />
      <ProudMembers />
      <RequestCallback /> 
    </div>
  )
}

export default Home
